// 对比分析
import main from "../../views/compareAnalysis/views/main/index.vue";
export const compareRouter = [
  {
    path: "/compare",
    name: "compare",
    component: main,
    redirect: "/compare/select-teacher",
    children: [
      // 选择对比项
      {
        path: "/compare/select-teacher",
        name: "compareSelectTeacher",
        component: () => import("../../views/compareAnalysis/views/select-teacher/index.vue"),
        meta: {
          transparency_Head: true,
          affiliation_Head: "KnowledgeGraph", // 归属级 (头部的)
          affiliation_Left: "KnowledgeGraph", // 归属级 (左侧的)
          // skip_login: true, // 免登录 设置为true
        },
      },
      // 对比分析
      {
        path: "/compare/analysis",
        name: "compareAnalysis",
        component: () => import("../../views/compareAnalysis/views/analysis/index.vue"),
        meta: {
          transparency_Head: true,
          affiliation_Head: "KnowledgeGraph", // 归属级 (头部的)
          affiliation_Left: "KnowledgeGraph", // 归属级 (左侧的)
          // skip_login: true, // 免登录 设置为true
        },
      },
      {
        path: "/compare/setting",
        name: "compareSetting",
        component: () => import("../../views/compareAnalysis/views/settings/index.vue"),
        meta: {
          transparency_Head: true,
          affiliation_Head: "KnowledgeGraph", // 归属级 (头部的)
          affiliation_Left: "KnowledgeGraph", // 归属级 (左侧的)
          // skip_login: true, // 免登录 设置为true
        },
      },
    ]}
];
